export const normalizeTextString = (
  inputString: string,
  trimWhitespace = false,
) => {
  let returnString = '';
  if (inputString) {
    returnString =
      inputString
        .toLocaleLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') || '';
  }
  return trimWhitespace ? returnString.trim() : returnString;
};
